module.exports = __webpack_public_path__ + "8d6e3833ae2a8f51ed6c0fc33c1292ea.svg";